import { BaseExportService } from "./BaseExportService";

export class EnterpriseCreditExportService extends BaseExportService {
  constructor(data, metadata = {}) {
    super(data, metadata);
    this.company_info = data?.CompanySearch || {};
    this.header = data?.Header || {};
    this.score_data = data?.CV4BCB01S?.CV4BCB01 || {};
  }

  get_filename_prefix() {
    return `Enterprise_Credit_Report_${this.company_info?.RegNo || "Unknown"}`;
  }

  get_available_sections() {
    return {
      company_details: "Company Details",
      credit_score: "Credit Score",
      principals: "Principals (Current & Previous)",
      vat_numbers: "VAT Numbers",
      raw_json: "Raw JSON Data",
    };
  }

  get_default_export_options() {
    return {
      company_details: true,
      credit_score: true,
      principals: true,
      vat_numbers: false,
      raw_json: false,
    };
  }

  prepare_export_data(export_options) {
    const export_data = {};

    if (export_options.company_details) {
      export_data.company_details = this.prepare_company_details();
    }

    if (export_options.credit_score) {
      export_data.credit_score = this.prepare_score_data();
    }

    if (export_options.principals) {
      export_data.principals = this.prepare_principals();
    }

    if (export_options.vat_numbers) {
      export_data.vat_numbers = this.prepare_vat_numbers();
    }

    if (export_options.raw_json) {
      export_data.raw_json = [this.data];
    }

    return export_data;
  }

  prepare_company_details() {
    return [
      {
        "Business Name": this.company_info.BusinessName,
        "Registration Number": this.company_info.RegNo,
        "Tax Number": this.header.TaxNumber,
        Status: this.company_info.RegStatus,
        Address: this.company_info.PhysicalAddress,
        City: this.company_info.Town,
        "Post Code": this.company_info.PostCode,
        "Start Date": this.header.StartDate,
      },
    ];
  }

  prepare_score_data() {
    const vars = this.score_data?.CreditVisionVariable?.CV4BVariableCB01 || [];
    const score_var = vars.find((v) => v.VariableName === "CV4BSCORE");
    const band_var = vars.find((v) => v.VariableName === "CV4BBAND");

    return [
      {
        "Credit Score": score_var?.VariableValue || "N/A",
        "Risk Band": band_var?.VariableValue || "N/A",
        "Liquidation Score": vars.find((v) => v.VariableName === "LIQSCORE")
          ?.VariableValue,
        "Judgment Score": vars.find((v) => v.VariableName === "JDGSCORE")
          ?.VariableValue,
        "Delinquency Score": vars.find((v) => v.VariableName === "DLQSCORE")
          ?.VariableValue,
      },
    ];
  }

  prepare_principals() {
    const current = this.data?.Principals?.Principal || [];
    const archived = this.data?.PrincipalArchivesP5?.PrincipalArchiveP5 || [];

    const current_rows = current.map((p) => ({
      Name: [p.Forename1, p.Forename2, p.Forename3, p.Surname]
        .filter((n) => n && n !== "None")
        .join(" "),
      "ID Number": p.IDNumber,
      Position: p.Position,
      "Date Started": p.DateStarted,
      "Date Resigned": "",
      Status: "Active",
    }));

    const archived_rows = archived.map((p) => ({
      Name: [p.Initials, p.Surname].filter((n) => n && n !== "None").join(" "),
      "ID Number": p.IDNumber,
      Position: p.Position,
      "Date Started": p.DateStarted,
      "Date Resigned": p.DateResigned,
      Status: p.Status || "Resigned",
    }));

    return [...current_rows, ...archived_rows];
  }

  prepare_vat_numbers() {
    const vats = this.header?.VATNumbers?.string || [];
    return vats.map((v) => ({ "VAT Number": v }));
  }
}
